import React from 'react';

const SrPartnerApprovalAddendaCheckbox = () => {
  return (
    <img
      style={{ position: 'relative', bottom: '2px' }}
      alt='checkbox'
      src='/images/checkbox-checked-addenda.png'
    />
  );
};

SrPartnerApprovalAddendaCheckbox.displayName = 'SrPartnerApprovalAddendaCheckbox';

export default SrPartnerApprovalAddendaCheckbox;
